module.exports = __webpack_public_path__ + "img/edit-2.cecd86c8.svg";